// extracted by mini-css-extract-plugin
export default {"speech-file":"speech-file_jpicI","close-icon":"close-icon_eRyA5"};